export { default as SkipLinkControl } from './components/SkipLinkControl';
